import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import ContentControlWrapper from '../ContentControlWrapper';
// @ts-expect-error Untyped module
import InterstitialContentViewport from './InterstitialContentViewport';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'basic-interstitial';
const BasicInterstitial = ({
  buttonLink,
  buttonI18n,
  buttonUse = 'primary',
  illustrationName,
  headingI18n,
  onButtonClick = () => {},
  subheadingI18n,
  testId = 'interstitial',
  use = 'info'
}) => /*#__PURE__*/_jsxs("div", {
  className: `${BASE_CLASS_NAME} ${BASE_CLASS_NAME}--${use}`,
  "data-test-id": testId,
  children: [/*#__PURE__*/_jsxs(InterstitialContentViewport, {
    use: use,
    wrapperClassName: `${BASE_CLASS_NAME}__content`,
    wrapperStyle: {
      minHeight: '450px',
      padding: '50px'
    },
    children: [illustrationName && /*#__PURE__*/_jsx(UIIllustration, {
      alt: I18n.text('learningCenter.tracks.interstitials.illustration'),
      name: illustrationName,
      width: "110"
    }), /*#__PURE__*/_jsx("p", {
      className: `${BASE_CLASS_NAME}__heading`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: headingI18n
      })
    }), /*#__PURE__*/_jsx("p", {
      className: `${BASE_CLASS_NAME}__subheading`,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: subheadingI18n
      })
    })]
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    children: buttonLink ? /*#__PURE__*/_jsx(UIRouterButton, {
      className: `${BASE_CLASS_NAME}__next-button`,
      onClick: onButtonClick,
      to: buttonLink,
      use: buttonUse,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonI18n
      })
    }) : /*#__PURE__*/_jsx(UIButton, {
      className: `${BASE_CLASS_NAME}__next-button`,
      onClick: onButtonClick,
      use: buttonUse,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonI18n
      })
    })
  })]
});
export default BasicInterstitial;